export default {"src":"/_next/static/media/user.8d0b2e56.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};